module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_1358201845683007.309a3afa.jpg";